import React from 'react';
import { ApertureIcon } from 'lucide-react';
import FluidIcon from '../../components/icons/FluidIcon';
import CardsIcon from '../../components/icons/CardsIcon';
const styleOptions = [
    {
        value: 'fluid',
        label: 'Fluid',
        icon: () => React.createElement(FluidIcon, { className: "text-gray-500", style: { width: 20 } }),
    },
    {
        value: 'cards',
        label: 'Cards',
        icon: () => React.createElement(CardsIcon, { className: "text-gray-500", style: { width: 20 } }),
    },
    {
        value: 'classic',
        label: 'Classic',
        icon: () => (React.createElement("svg", { width: "20", height: "20", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: "text-gray-500" },
            React.createElement("path", { d: "M14 2H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h2" }),
            React.createElement("rect", { x: "8", y: "2", width: "8", height: "4", rx: "1", ry: "1" })))
    },
    {
        value: 'inmersive',
        label: 'Inmersive',
        icon: ApertureIcon
    }
];
export const FormStyleSelector = ({ selectedStyle, onStyleChange, title = "Form Style" }) => {
    return (React.createElement("div", { className: "mb-6" },
        React.createElement("label", { className: "block text-sm font-medium text-gray-700 mb-2" }, title),
        React.createElement("div", { className: "grid grid-cols-4 gap-3" }, styleOptions.map((option) => {
            const IconComponent = option.icon;
            const isSelected = selectedStyle === option.value;
            return (React.createElement("div", { key: option.value, className: `border rounded-lg p-2 flex flex-row items-center cursor-pointer transition-all ${isSelected
                    ? 'border-orange-500 bg-orange-50'
                    : 'border-gray-200 hover:border-gray-300'}`, onClick: () => onStyleChange(option.value) },
                React.createElement("div", { className: "h-10 w-10 bg-gray-100 rounded flex items-center justify-center" },
                    React.createElement(IconComponent, { size: 20, className: "text-gray-500" })),
                React.createElement("span", { className: "mx-2 text-sm font-medium" }, option.label)));
        }))));
};
export default FormStyleSelector;
